import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { alignVariants } from "@huub-web/ui/utils/vanilla/alignVariants";
import { transition } from "@huub-web/ui/utils/transition";
import { transitionDurations } from "@huub-web/ui/theme/transitionDurations";

/**
 * Style recipe for the illustration container with size variants
 */
export const illustrationContainerStyle = recipe({
  base: {
    margin: 0,
    padding: 0,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    flexGrow: 0,
    opacity: 0,
    userSelect: "none",
    transition: transition(
      "opacity",
      {
        property: "transform",
        duration: `${transitionDurations.l}s`,
      },
      "background-color",
    ),
  },
  variants: {
    size: {
      xxs: {
        width: rem(100),
        height: rem(100),
      },
      xs: {
        width: rem(120),
        height: rem(120),
      },
      s: {
        width: rem(160),
        height: rem(160),
      },
      m: {
        width: rem(200),
        height: rem(200),
      },
      l: {
        width: rem(300),
        height: rem(300),
      },
      auto: {
        width: "auto",
        height: "auto",
      },
    },
    loaded: {
      true: {
        opacity: 1,
      },
    },
    alignSelf: alignVariants("alignSelf"),
    hover: {
      true: {
        transform: "scale(1.03)",
      },
    },
  },
  defaultVariants: {
    size: "m",
  },
});

export const svgStyle = recipe({
  base: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    zIndex: 1,
  },
  variants: {
    theme: {
      light: {},
      dark: {
        filter: "invert(1)",
      },
    },
  },
});

export const headStyle = recipe({
  base: {
    transition: transition("transform", {
      property: "transform",
      duration: `${transitionDurations.m}s`,
    }),
  },
  variants: {},
});
